import { ReactElement } from 'react';
import {
  IndeterminateResultIcon,
  NegativeResultIcon,
  PositiveResultIcon,
} from '@root/src/assets/images';
import { ResultOptionType } from '../../order/types';
import { IndeterminateLabel, NegativeLabel, PositiveLabel } from './styles';

interface PropsI {
  result: ResultOptionType;
  dataTestId?: string;
}

export const getResultIcon = (result: ResultOptionType): ReactElement => {
  switch (result) {
    case 'negative':
      return <NegativeResultIcon />;
    case 'positive':
      return <PositiveResultIcon />;
    case 'indeterminate':
    default:
      return <IndeterminateResultIcon />;
  }
};

const ResultLabel = ({ result, dataTestId }: PropsI): ReactElement => {
  switch (result) {
    case 'negative':
      return (
        <NegativeLabel data-testid={dataTestId}>
          {getResultIcon(result)}
          {result && result[0].toUpperCase() + result.slice(1)}
        </NegativeLabel>
      );
    case 'positive':
      return (
        <PositiveLabel data-testid={dataTestId}>
          {getResultIcon(result)}
          {result && result[0].toUpperCase() + result.slice(1)}
        </PositiveLabel>
      );
    case 'indeterminate':
    default:
      return (
        <IndeterminateLabel data-testid={dataTestId}>
          {getResultIcon(result)}
          {result && result[0].toUpperCase() + result.slice(1)}
        </IndeterminateLabel>
      );
  }
};

export default ResultLabel;
